import { fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { showGlobalToast } from "../../Components/ToastProvider";
import router from "../../Routes";
import { logout } from "../Slices/reducer";

const rawBaseQuery = fetchBaseQuery({
  baseUrl: import.meta.env.VITE_API,
  prepareHeaders: (headers, { getState }) => {
    const token = getState().adminsSlice?.token;
    if (token) headers.set("Authorization", `Bearer ${token}`);
    // headers.set("Content-Type", "application/json");
    return headers;
  },
});

export const customFetchBase =
  ({ url }) =>
  async (args, api, extraOptions) => {
    const fixedArgs = {
      ...args,
      url: url + (args.url || ""),
    };

    const result = await rawBaseQuery(fixedArgs, api, extraOptions);

    if (result?.error?.status === 401) {
      showGlobalToast("لظفا دوباره وارد شوید");
      api.dispatch(logout());
      router.navigate("/auth");
    }

    return result;
  };

// READ‌ME
// in default it will send token and json type , but
// you cant override headers or send more in query of RTK
